import './App.css';
import React from 'react';
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Manager from './Views/Dashboard/Pages/Manager';
import Merger from './Views/Dashboard/Pages/Merger';
import Metadata from './Views/Dashboard/Pages/Metadata';
import Watermark from './Views/Dashboard/Pages/Watermark';
import Dashboard from './Views/Dashboard/Dashboard';
import Rotate from './Views/Dashboard/Pages/Rotate';
import MainLayout from './Views/Layout/MainLayout';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
          {/* Base*/}
          <Route element={<MainLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="pdf-seiten-löschen" element={<Manager />} />
            <Route path="pdf-seiten-bearbeiten" element={<Manager />} />
            <Route path="pdf-metadaten-bearbeiten" element={<Metadata />} />
            <Route path="pdf-zusammenfuegen" element={<Merger />} />
            <Route path="pdf-wasserzeichen-hinzufuegen" element={<Watermark />} />
            <Route path="pdf-seiten-drehen" element={<Rotate />} />
          </Route>
        <Route path="*" element={<Navigate to={"/"} />} />
      </Route>
    </Routes>
  );
}

/* Main Layout */
function Layout() {
  return (
    <div className="flex bg-[#D9D9D9] overflow-hidden h-dvh w-full" >
      <Outlet />
    </div>
  )
}

export default App;
